import { SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  placeholder?: boolean;
  sx?: SxProps;
};

const EmptyStateText = ({ placeholder, sx }: Props) => {
  const { t } = useTranslation("talentProfile");

  return (
    <Typography
      variant="header"
      color="text.disabled"
      sx={{
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: "10px",
        letterSpacing: "4%",
        ...sx,
      }}
    >
      {placeholder
        ? t("profileSummary.comingSoon")
        : t("profileSummary.emptyState")}
    </Typography>
  );
};

export default EmptyStateText;
